export const eventsData = [
	{
		img: './assets/masonry1.jpg',
	},
	{
		img: './assets/masonry2.jpg',
		class: 'tall',
	},

	{
		img: './assets/masonry3.jpg',
	},
	{
		img: './assets/masonry11.jpg',
		class: 'wide',
	},
	{
		img: './assets/masonry4.jpg',
		class: 'big',
	},
	{
		img: './assets/masonry5.jpg',
	},
	{
		img: './assets/masonry6.jpg',
		class: 'tall',
	},
	{
		img: './assets/masonry10.jpg',
		class: 'tall',
	},
	{
		img: './assets/masonry7.jpg',
	},
	{
		img: './assets/masonry8.jpg',
	},
	{
		img: './assets/masonry9.jpg',
	},
];
